import { ReactNode } from 'react';

import { MenuItem, MenuItemIcon } from './styles';

type ActionItemProps = {
  icon: ReactNode;
  onClick: () => void;
  label?: string;
  children?: ReactNode;
};

export const ActionItem = ({
  icon,
  onClick,
  label,
  children,
}: ActionItemProps) => (
  <MenuItem
    role="menuitem"
    tabIndex={0}
    onClick={onClick}
    onKeyDown={e => e.key === 'Enter' && onClick()}
  >
    <MenuItemIcon>{icon}</MenuItemIcon>
    {label || children}
  </MenuItem>
);
